import { Component, OnInit } from '@angular/core';
import {  SettingsService } from 'src/app/shared';
import { first } from 'rxjs/operators';

@Component({
  selector: 'app-app-header',
  templateUrl: './app-header.component.html',
  styleUrls: ['./app-header.component.scss']
})
export class AppHeaderComponent implements OnInit {
 
  dataAvailable = false;  
  bannerType:any ;
  fileType:any = "image/jpg,image/jpeg,image/png";
  //uploadType="image";
  error:any;
  logoid :any;

  
  constructor(private settingsService: SettingsService) { }

  ngOnInit() {
    this.getAppHeader(); 
     
    this.dataAvailable = true;
  }


  getAppHeader(){
    this.settingsService.getSettings()
    .pipe(first())
    .subscribe(res => {
     
      this.bannerType = res['banner_type'] || 'banner_text';
      
     });
  }


  

  onLogoUploaded (e){
   



  }
  
 
  ondocError(e){
    this.error=e;
  }

 
  onSelectionChange (bannerType){
    this.settingsService.setHeaderPreference(bannerType)
    .pipe(first())
    .subscribe(res => {
     
       //alert..
      
     });
  }
}
